const TextAreaComponent = (
  {
    lableValue,
    textareaName,
    textareaDefaultValue,
    textareaId,
    textareaCols,
    textareaRows,
    onChange
  }
) => {
  return (
    <div>
      <label
      //  htmlFor=""
      >
        {lableValue}
      </label>
      <textarea
        className="w-100"
        name={textareaName}
        id={textareaId}
        cols={textareaCols}
        rows={textareaRows}
        onChange={onChange}
        defaultValue={textareaDefaultValue}
      >

      </textarea>
    </div>
  )
}

export default TextAreaComponent